import { render, staticRenderFns } from "./OrdemDeServicoLiberarItensView.vue?vue&type=template&id=75ea4b34&scoped=true"
import script from "./OrdemDeServicoLiberarItensView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemDeServicoLiberarItensView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdemDeServicoLiberarItensView.vue?vue&type=style&index=0&id=75ea4b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ea4b34",
  null
  
)

export default component.exports